<template>
  <div id="keycard-view" class="flex-grow bg-white block">
      <ria-input-action
        class="h-16 items-center"
        :value="$t('participants.keycard.ihaveone')"
        :action="goToIHaveKeykard" />
      <ria-input-action
        v-if="checkKeycard"
        class="h-16 items-center"
        :value="$t('participants.keycard.ineedone')"
        :action="goToNewKeykard" />
  </div>
</template>

<script>
  import RiaInputAction from "@/components/form/elements/ria-input-action";
  import {keepScroll} from "../mixins";
  import {mapGetters} from 'vuex';

  export default {
    name: "Keycard",
    mixins: [keepScroll],
    data() {
      return {
        'index':this.$route.params.participantIndex,
      }
    },
    components: {
      RiaInputAction
    },
    computed: {
      ...mapGetters('resort', ["selectedCatalog"]),
      checkKeycard: function() {
        return this.selectedCatalog.products.find(product => product.type.code === 'keycard' && product.active)
      }
    },
    methods: {
      goToIHaveKeykard() {
        this.$router.push({ name: 'KeycardSelect',params: { participantIndex: `${this.index}` }})
      },
      goToNewKeykard() {
        this.$router.push({ name: 'KeycardNew',params: { participantIndex: `${this.index}` }})
      },
      confirmKeycard: function() {
        this.$store.commit('participants/SET_DETAIL_FIELD', {
          index: this.$route.params.participantIndex,
          field: 'keycard',
          value: this.keycard
        })
        this.$router.back()
      }
    }
  };
</script>

<style>
  #keycard-view {
    @apply pl-5
  }
  #keycard-view .contenidor{
    @apply m-0
  }
  #keycard-view .contenidor:last-child{
    @apply border-0
  }
  #keycard-view .value{
    @apply text-1sm
  }
</style>
